const C = require("../constants");

const ticketCheckModal = (data) => {
    return {
        type: C.TICKET_CHECK_DIALOG,
        data
    }
};

export {ticketCheckModal};


// WEBPACK FOOTER //
// ./src/actions/TicketCheckActions.js